import * as loadImage from 'blueimp-load-image';

import { canvasToBlob } from '$utils/index';
import { Api } from '$api';

interface ImageSize {
  width: number;
  height: number;
}

export const getImageSize = (file: File) =>
  new Promise<ImageSize>((resolve) => {
    const image = new Image();
    image.src = window.URL.createObjectURL(file);
    image.addEventListener('load', () => {
      const { width, height } = image;
      resolve({ width, height });
      window.URL.revokeObjectURL(image.src);
    });
  });

export const getImageSizeByUrl = (src: string, revoke = true) =>
  new Promise<ImageSize>((resolve) => {
    const image = new Image();
    image.src = src;
    image.addEventListener('load', () => {
      const { width, height } = image;
      resolve({ width, height });
      revoke && window.URL.revokeObjectURL(image.src);
    });
  });

export async function uploadImage(file: File) {
  const data = await loadImage(file, {
    maxWidth: 1920,
    maxHeight: 1920,
    meta: true,
    canvas: true,
    imageSmoothingEnabled: true,
    imageSmoothingQuality: 'high',
    orientation: true,
  });

  const quality = 0.92;
  const base64 = data.image.toDataURL('image/jpeg', quality);
  const blob = await canvasToBlob(data.image, quality);
  const width = data.image.width;
  const height = data.image.height;

  const form = new FormData();
  form.append('file', blob);
  form.append('album_id', `-3`);

  const resp: any = await Api.post('/photos/upload', form);
  return {
    id: +resp.photo_id,
    base64,
    width,
    height,
  };
}
